export const environment = {
    production: false,
    //for organonDev
    idmUrl: 'https://javelin.staging.zsservices.com/Organon/IdentityManager/app/Web/Login.aspx?ReturnUrl=https://cds.stage.organon.zsservices.com/projects',
    organization: 'ORGANON',
    accessRequestUrl : '',
    mailDl :''
  
  };
